import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { UploadProvider } from "../context/UploadProvider/indexUpload";
import { RouteProvider } from "../context/RouteProvider";
import GridProvider from "../context/GridProvider/GridContext";
import { SearchConfigProvider } from "../context/SearchConfigProvider/SearchConfig";
import { useUpload } from "../context/UploadProvider/useUpload";
import i18n from "../pages/i18n/I18n";

// Page Imports
import ErrorPage from "../pages/ErroPage/ErrorPage";
import ServerDontAllowed from "../pages/ErroPage/ServerDontAllowed";
import GroupsList from "../pages/Groups/GroupsList";
import OrganizationConfig from "../pages/Organization/OrganizationConfig";
import ProtectedLayout from "../pages/ProtectedLayout/ILayoutProtected";
import PublicLayout from "../pages/PublicLayout/ILayoutPublic";
import Login from "../pages/User/Login/LoginComp";
import NewUserPassword from "../pages/User/NewPassword/NewUserPassword";
import ListUserOrg from "../pages/User/UserList/ListUserOrg";
import { AdminConsole } from "../pages/AdminConsole/Home/AdminConsole";
import { AccountAndSubscription } from "../pages/AdminConsole/AccountAndSubscription/AccountAndSubscription";
import { UsersAndGroups } from "../pages/AdminConsole/UsersAndGroups/UsersAndGroups";
import { GroupPage } from "../pages/AdminConsole/UsersAndGroups/components/GroupPage/GroupPage";
import { GroupPanel } from "../pages/AdminConsole/UsersAndGroups/components/GroupPanel/GroupPanel";
import { UserPanel } from "../pages/AdminConsole/UsersAndGroups/components/UserPanel/UserPanel";
import { WorkspacesPage } from "../pages/AdminConsole/Workspaces/Workspaces";
import { ConfigWorkspace } from "../pages/AdminConsole/Workspaces/components/NewWorkspace/ConfigWorkspace";
import { WorkspaceDetails } from "../pages/AdminConsole/Workspaces/components/WorkspaceDetails/WorkspaceDetails";
import ReturnBackEndParameters from "../pages/BackEndParameters/ReturnBackEndParameters";
import DocumentTypeConfig from "../pages/DocumentType/DocumentTypeConfig";
import DocumentTypesList from "../pages/DocumentType/DocumentTypeList";
import Acept from "../pages/EmailAcept/Acept";
import GroupUsers from "../pages/Groups/GroupUsers/GroupUsers";
import { Feed } from "../pages/Feed/Feed";
import LinkToFilePage from "../pages/LinkToFile/LinkToFilePage";
import RecycleBinList from "../pages/RecicleBin/RecycleBinList";
import LogErrorsList from "../pages/LogErrors/LogErrorsList";
import OrganizationInfo from "../pages/LoggedHome/OrganizationInfo";
import MfaQRCode from "../pages/User/MfaQRCode/MfaQRCode";
import EmailSendSuccess from "../pages/User/ResetPassword/EmailSendSuccess";
import ResetPassword from "../pages/User/ResetPassword/ResetPasswordComp";
import ResetPasswordSuccess from "../pages/User/ResetPassword/ResetPasswordSuccess";
import MfaOTP from "../pages/User/MfaOTP/MfaOTP";
import { MyData } from "../pages/MyDataPage/MyData";
import { AllResults } from "../pages/AllResults/AllResults";
import { Pendencies } from "../pages/UserPendencies/Pendencies";
import ValidationRuleCreateEdit from "../pages/ValidationRule/ValidationRuleCreateEdit/ValidationRuleCreateEdit";
import ValidationRuleList from "../pages/ValidationRule/ValidationRuleList/ValidationRuleList";
import WizardFreeMain from "../pages/WizardFree/WizardFreeMain";
import WorkSpacePermissions from "../pages/WorkSpace/Permissions/WorkSpacePermissions";
import WorkSpaceList from "../pages/WorkSpace/WorkSpaceList";
import PermissionGroupFolder from "../pages/WorkSpaceItem/PermissionFolder/PermissionGroup/PermissionGroupFolder";
import PermissionUserFolder from "../pages/WorkSpaceItem/PermissionFolder/PermissionUser/PermissionUserFolder";
import WorkSpaceItemMain from "../pages/WorkSpaceItem/WorkSpaceItemMain";
import SharedFileAcess from "../pages/SharedFile/SharedFileAcess";
import TemporalityMenu from "../pages/Temporality/MenuWorkspace/TemporalityMenu";
import TemporalityList from "../pages/Temporality/Report/TemporalityList";
import { SharedItem } from "../pages/SheredItem/SharedItem";
import AddNewDevice from "../pages/AddNewDevice/AddNewDevice";
import Plans from "../pages/Plans/Plans";
import Register from "../pages/User/Register/Register";
import ChoosePlan from '../pages/Plan/ChoosePlan';
import PlanCheckout from '../pages/PlanCheckout/PlanCheckout';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../services/stripe';
import { GuestUserPanel } from '../pages/AdminConsole/UsersAndGroups/components/UserPanel/GuestUserPanel';

import { DashboardAdmin } from '../pages/AdminConsole/Dashboard/DashboardAdmin';
import WorkSpaceAdmList from "../pages/WorkSpace/WorkspaceAdm/WorkSpaceAdmList";

const AppRoutes = () => {
    const auth = useUpload();

    return (
        <UploadProvider>
            <Elements stripe={stripePromise}>
                <GridProvider>
                    <SearchConfigProvider>
                        <BrowserRouter>
                            <RouteProvider>
                                <Routes>
                                    <Route path="/acept" element={<Acept />} />
                                    <Route path="/sharedfile" element={<SharedFileAcess />} />
                                    <Route path="/backEndParameters" element={<ReturnBackEndParameters />} />
                                    <Route element={<ProtectedLayout />}>
                                        <Route path="/file/:idFile" element={<LinkToFilePage />} />
                                        <Route path="/" element={<OrganizationInfo />} />
                                        <Route path="/:nameOrg" element={<OrganizationInfo />} />
                                        <Route path="/:nameOrg/allResults" element={<AllResults />} />
                                        <Route path="/:nameOrg/mydata" element = { <MyData /> } />
                                        <Route path="/:nameOrg/groups" element = {   <GroupsList />  }  />
                                        <Route path="/:nameOrg/groups/:idGroup" element = {   <GroupUsers />  }  />
                                        <Route path="/:nameOrg/users" element = {   <ListUserOrg />  }  />
                                        <Route path="/:nameOrg/config" element = { <OrganizationConfig/>  } />
                                        <Route path="/:nameOrg/preferences" element = { <OrganizationConfig/>  } />
                                        <Route path="/:nameOrg/WorkSpace" element = {   <WorkSpaceList />  }  />     
                                        <Route path="/:nameOrg/wsallowed" element = {   <WorkSpaceAdmList />  }  />     
                                        <Route path="/:nameOrg/:idWorkspace/Permission" element = {   <WorkSpacePermissions />  }  />         
                                        <Route path="/:nameOrg/temporality/" element = {   <TemporalityMenu />  }  />
                                        <Route path="/:nameOrg/:idWorkspace/temporality" element = {   <TemporalityList />  }  />
                                        <Route path="/logErrors" element = {   <LogErrorsList />  }  />

                                        <Route path="/:nameOrg/recycleBin/" element={<RecycleBinList />} />
                                        <Route path="/:nameOrg/wsallowed/:idWorkspace/:idFolder" element={<WorkSpaceItemMain />} />
                                        <Route path="/:nameOrg/wsallowed/:idWorkspace" element={<WorkSpaceItemMain />} />
                                        <Route path="/:nameOrg/wsallowed/:idWorkspace/Permission" element={<WorkSpacePermissions />} />
                                        <Route path="/:nameOrg/wsallowed/:idWorkspace/:idFolder/PermissionUser" element={<PermissionUserFolder />} />

                                        <Route path="/:nameOrg/:idWorkspace/validationRule" element={<ValidationRuleList />} />
                                        <Route path="/:nameOrg/:idWorkspace/validationRule/:idValidationRule" element={<ValidationRuleCreateEdit />} />
                                        <Route path="/:nameOrg/:idWorkspace/documentTypes" element={<DocumentTypesList />} />
                                        <Route path="/:nameOrg/:idWorkspace/documetTypes/:idDocumentTypes" element={<DocumentTypeConfig />} />
                                        <Route path="/:nameOrg/:idWorkspace/UserPendencies" element={<Pendencies />} />
                                        <Route path="/:nameOrg/Item/tracker" element={<Feed />} />
                                        <Route path="/:nameOrg/SharedItem" element={<SharedItem />} />
                                        <Route path="/:nameOrg/adminConsole" element={<AdminConsole />} />
                                        <Route path="/:nameOrg/adminConsole/accountAndSubscription" element={<AccountAndSubscription />} />
                                        <Route path="/:nameOrg/adminConsole/usersAndGroups" element={<UsersAndGroups />} />
                                        <Route path="/:nameOrg/adminConsole/usersAndGroups/newUser" element={<UserPanel />} />
                                        <Route path="/:nameOrg/adminConsole/usersAndGroups/newGuestUser" element={<GuestUserPanel />} />
                                        <Route path="/:nameOrg/adminConsole/usersAndGroups/newGroup" element={<GroupPanel />} />
                                        <Route path="/:nameOrg/adminConsole/usersAndGroups/:idGroup" element={<GroupPage />} />
                                        <Route path="/:nameOrg/adminConsole/workspaces" element={<WorkspacesPage />} />
                                        <Route path="/:nameOrg/adminConsole/workspaces/config/" element={<ConfigWorkspace />} />
                                        <Route path="/:nameOrg/adminConsole/workspaces/config/:idWorkspace" element={<ConfigWorkspace />} />
                                        <Route path="/:nameOrg/adminConsole/workspaces/:idWorkspace" element={<WorkspaceDetails />} />
                                        <Route path="/:nameOrg/adminConsole/dashboard" element = {   <DashboardAdmin />  }  />   
                                        <Route path="/:nameOrg/adminConsole/plans" element={<Plans />} />
                                        <Route path="/plans" element={<ChoosePlan />} />
                                        <Route path="/reload-temp" element={<div>Carregando...</div>} />
                                    </Route>

                                    <Route element={<PublicLayout />}>
                                        <Route path="/wizard" element={<WizardFreeMain />} />
                                        <Route path="/acceptedTrustedDevice" element={<AddNewDevice />} />
                                        <Route path="/login" element={<Login />} />
                                        <Route path="/register" element={<Register />} />
                                        <Route path="/login/otp/:email" element={<MfaOTP />} />
                                        <Route path="/login/qrcode/:email/:key" element={<MfaQRCode />} />
                                        <Route path="/newPassWord" element={<NewUserPassword />} />
                                        <Route path="/serverDontAllowed" element={<ServerDontAllowed />} />
                                        <Route path="/newPassWord" element={<NewUserPassword />} />
                                        <Route path="/resetPassword" element={<ResetPassword />} />
                                        <Route path="/emailSendSuccess" element={<EmailSendSuccess />} />
                                        <Route path="/resetPasswordSuccess" element={<ResetPasswordSuccess />} />
                                        <Route path="/plan/:email/:nameOrg" element={<ChoosePlan />} />
                                        <Route path="/plan-checkout/:userEmail" element={<PlanCheckout />} />
                                    </Route>

                                    <Route path="*" element={<ErrorPage />} />
                                </Routes>
                            </RouteProvider>
                        </BrowserRouter>
                    </SearchConfigProvider>
                </GridProvider>
            </Elements>
        </UploadProvider>
    )
};

export default AppRoutes;